import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import ReusableCertifiedIcon from "./ReusableCertifiedIcon";
import DatasetDetailsMessageMain from "./DatasetDetailsMessageMain";
import DatasetDetailsMessageSub from "./DatasetDetailsMessageSub";
import axios from "axios";
import { TELEMETRY_API } from "../../constants/serverConfig";

const ReusableHeader = ({
  value,
  // setValue,
  description,
  setDatasetDescription,
  id,
  certifiedetails,
  savedescription,
  setDescToggle,
  desctoggle,
  modaldata,
  toggleloading,
  updateCertificationDetails,
  showModal,
  datasetId
}) => {

  const editToggle = () => {
    setDescToggle(!desctoggle)
  }
  const [copydatasetid, setCopyDatasetId] = useState(false);
  const [copiedmsg, setCopyMessage] = useState("");
  const [sensitivitytypeclass, setSensitivityTypeClass] = useState("");
  let certifieddata = certifiedetails?.certifiedFlag ? (
    <ReusableCertifiedIcon certifieddata={certifiedetails} />
  ) : (
    ""
  );
  const classificationType = () => {
    let confidenceFlag = modaldata.securityClassification?.some(function (
      object
    ) {
      return object?.indexOf("confidential") > -1;
    });
    let internalFlag = modaldata.securityClassification?.some(function (
      object
    ) {
      return object?.indexOf("internal") > -1;
    });
    let publicFlag = modaldata.securityClassification?.some(function (object) {
      return object?.indexOf("public") > -1;
    });

    if (confidenceFlag) {
      setSensitivityTypeClass("sensitivity-confidencial");
    } else if (internalFlag) {
      setSensitivityTypeClass("sensitivity-internal");
    } else if (publicFlag) {
      setSensitivityTypeClass("sensitivity-public");
    } else {
      setSensitivityTypeClass("bg-white");
    }
    // setSensitivityType("#008000")
  };


  useEffect(() => {
    classificationType();
  }, [modaldata]);

  const copydataset = (value, message) => {
    setCopyDatasetId(true);
    setCopyMessage(message);
    navigator.clipboard.writeText(value);

    setTimeout(
      () => {
        setCopyDatasetId(false)
        setCopyMessage("");
      },
      2000
    );

  }





  return (
    <Container className="crumb__width1 p30" fluid>
      <Row>
        <div className="datasets__header__content1 text-dark">
          {/* {value === null ? (
            <>
              {certifieddata}
              <span className="dataset__name">{modaldata.fqn}</span>
            </>
          ) : (
            <>
              {certifieddata}
              <span className="dataset__name">{modaldata.fqn}</span>
            </>
          )} */}
          {copydatasetid ? (<div className="p-2 rounded aad-group-copy-msg me-5" >{copiedmsg}  </div>) : ""}

        </div>
        <div>
          <div className="details-head-card"
            style={{
              width: "100%"
            }} >
            <DatasetDetailsMessageMain
              id={id}
              modaldata={modaldata}
              copydataset={copydataset}
              certifiedetails={certifiedetails}
              desctoggle={desctoggle}
              savedescription={savedescription}
              editToggle={editToggle}
              // setValue={setValue}
              description={description}
              setDatasetDescription={setDatasetDescription}
              value={value}
              toggleloading={toggleloading}
              updateCertificationDetails={updateCertificationDetails}
              showModal={showModal}
              sensitivitytypeclass={sensitivitytypeclass}

            />
            <DatasetDetailsMessageSub
              modaldata={modaldata}
              showModal={showModal}
              sensitivitytypeclass={sensitivitytypeclass}
              certifiedetails={certifiedetails}
              datasetId={datasetId}
            />
          </div>
          {/* <div>
            <div className="w-100">
              <label className="desc-heading"> Description </label>
              <div className="desc-edit-save">
                {desctoggle ? (<div onClick={(e) => savedescription(value)}><GiCheckMark size={20} className="me-3 cursor-pointer" /></div>) : ""}
                {" "}
                <BsPencilFill className="stroke-2 cursor-pointer rounded border" onClick={editToggle} />
              </div>
            </div>
          </div> */}
          {/* <div className="w-100">
            <Input.TextArea
              style={{ width: 1000 }}
              disabled={!desctoggle}
              size="large"
              placeholder="Table description goes here."
              value={value}
              onChange={(e) => setValue(e.target.value)}
              autoSize={desctoggle ? {
                minRows: 2,
                maxRows: 3
              } : {}}
              className="header-textarea text-dark"
            />
          </div>*/}
        </div>
      </Row>
    </Container>
  );
};

export default ReusableHeader;
